{
  "campaignName": "Lombard Lux",
  "platform": "Lombard",
  "description": "Points for providing liquidity.",
  "platformImageId": "lombard.png",
  "dashboardLink": "https://www.lombard.finance/app/dashboard/",
  "pools": [
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0x2f3bc4c27a4437aeca13de0e37cdf1028f3706f0",
      "network": "ethereum",
      "multiplier": "1x",
      "tags": ["points"],
      "lock": "false"
    },
    {
      "id": "null",
      "action": "lp",
      "description": "null",
      "campaignStart": "0",
      "campaignEnd": "1770000000",
      "address": "0xa7741d3d29a4391a7ca671d00e444342b6a8ad5a",
      "network": "ethereum",
      "multiplier": "1x",
      "tags": ["points"],
      "lock": "false"
    }
  ]
}
